export const loadGigyaScript = (config) => {
    const { src, async = true, innerHTML, onLoad, onError } = config;
    const scriptName = src.split('/').pop() || src;
    const scriptSelector = `script[src*="${scriptName}"]`;
    const existingScript = document.querySelector(scriptSelector);
    if (existingScript) {
        console.error(`Gigya script already exists`);
        return null;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    if (innerHTML) {
        script.innerHTML = innerHTML;
    }
    script.onload = () => {
        console.log(`Gigya script loaded successfully`);
        onLoad?.();
    };
    script.onerror = (error) => {
        console.error(`Failed to load gigya script`, error);
        onError?.(error);
    };
    document.body.appendChild(script);
    return script;
};
//# sourceMappingURL=load-gigya-script.js.map